import { useEffect, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import PayrollSlipExact from './genrate-payroll-issue-payment-accodian-card';

const ViewPayStub = ({ open, onClose, reload, payrollData, employeeTimeSheets }) => {
    const theme = useTheme();
    const formattedPayrollData = useMemo(() => {
        if (!payrollData) return null;
        return payrollData;
    }, [payrollData]);
    
    const formattedEmployeeData = useMemo(() => {
        if (!employeeTimeSheets) return [];
        
        if (employeeTimeSheets.original && employeeTimeSheets.original.payload) {
            return employeeTimeSheets.original.payload;
        }        
        return Array.isArray(employeeTimeSheets) ? employeeTimeSheets : [];
    }, [employeeTimeSheets]);
    const NewDocumentSchema = Yup.object().shape({});
    const defaultValues = useMemo(() => ({}), []);
    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });
    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [reset, defaultValues]);

    const onSubmit = handleSubmit(async (data) => {
     
    
    });
    return (
        <Dialog
            open={open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            }}
            fullWidth
            maxWidth="lg"
            sx={{
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            }}
            transitionDuration={{
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            }}
        >
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span
                        className='cardColor'
                        style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}
                    >
                        &nbsp;&nbsp; View Pay Stub &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={onClose}>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <PayrollSlipExact 
                        payrollData={formattedPayrollData} 
                        employeeData={formattedEmployeeData} 
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={onClose}>
                        Cancel
                    </Button>
                 
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};

export default ViewPayStub;